import type { ProductTileLookProps } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/product/product-tile';

export const CHIPOTLE_TILE_LOOK: ProductTileLookProps = {
  imageAspectClassName: 'aspect-[400/488]',
  imageObjectFit: 'contain',
  imageWrapperClassName: 'bg-white',
  availabilityTagsClassName: 'absolute right-15 top-30 z-10',
  availabilityTagClassName: 'font-primaryThin',
  availabilityTagClassNameByKey: { 'coming-soon': '!text-secondary-regular !border-secondary-regular font-primaryBold' },
  titleClassName:
    'text-md line-clamp-2 w-full min-w-0 overflow-hidden break-words pt-10 font-semibold leading-[1.2]',
  tooltipClassName: 'fixed z-[9999] w-max max-w-240 rounded border border-gray-300 bg-white p-12 text-left shadow-lg',
  priceRegularFontSize: 14,
  priceRegularClassName: 'text-left text-lg font-normal leading-3',
  priceAsHeading: false,
};

export const CHIPOTLE_UNMIXEABLE = {
  unmixeableContainerClassName: 'mt-32 w-full flex-col gap-8 rounded-lg border border-primary-regular',
  unmixeableMessageClassName: 'm-30 text-center md:text-16',
  unmixeableMessageFontSize: 14 as const,
  unmixeableClearButtonClassName:
    'w-full max-w-400 rounded-lg border border-primary-regular py-8 font-secondaryBold text-14 uppercase transition hover:opacity-50 md:text-16',
  unmixeableCheckoutButtonClassName:
    'w-full max-w-400 rounded-lg bg-secondary-regular py-8 font-secondaryBold text-14 uppercase text-white hover:opacity-50 md:text-16',
};
